var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12390_6556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#6C5CE7",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.063 11.2496C28.665 9.58346 31.2625 9.58346 32.8646 11.2496L34.7984 13.2608C36.4005 14.927 36.4005 17.6284 34.7984 19.2945L20.5872 34.0743C20.3963 34.2728 20.1531 34.4081 19.8884 34.4632L12.6364 35.9716C11.6796 36.1706 10.8359 35.2933 11.0273 34.2982L12.4777 26.7561C12.5307 26.4807 12.6608 26.2279 12.8517 26.0293L27.063 11.2496ZM31.8976 12.2552L33.8315 14.2665C34.8996 15.3772 34.8996 17.1781 33.8315 18.2889L31.4141 20.8029L25.6125 14.7693L28.0299 12.2552C29.0979 11.1445 30.8296 11.1445 31.8976 12.2552ZM24.6456 15.7749L13.8186 27.035L12.3682 34.5771L19.6202 33.0686L30.4472 21.8086L24.6456 15.7749Z",
    fill: "#2D3436"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12390_6556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroup);
export default __webpack_public_path__ + "static/media/edit-group.3de033ff683e834bf37c65609b6d0a76.svg";
export { ForwardRef as ReactComponent };